import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var EyeClosed = function EyeClosed(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.112 6.313a8.898 8.898 0 01-1.364 1.717l1.042 1.242a.6.6 0 01-.92.771l-1.039-1.238a8.259 8.259 0 01-1.419.838l.651 1.789a.6.6 0 11-1.127.41l-.647-1.775a8.08 8.08 0 01-1.689.31V12.2a.6.6 0 01-1.2 0v-1.824a8.079 8.079 0 01-1.69-.31l-.646 1.776a.6.6 0 11-1.127-.41l.65-1.789a8.256 8.256 0 01-1.418-.838l-1.04 1.238a.599.599 0 01-.845.075.6.6 0 01-.075-.846L2.252 8.03A8.885 8.885 0 01.888 6.313a.6.6 0 011.024-.626C3.258 7.887 5.534 9.2 8 9.2s4.742-1.313 6.088-3.513a.6.6 0 011.024.626z",
    fill: "currentColor"
  }));
};
export default EyeClosed;